import React from 'react';
import { ColumnsType } from 'antd/es/table';
import DetalleMetrica from './DetalleMetrica';

const DetalleDesmote: React.FC = () => {
  const columns: ColumnsType<any> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Nro. Fardo',
      dataIndex: 'nro_fardo',
      key: 'nro_fardo',
      width: 120,
      align: 'right' as const,
    },
    {
      title: 'Kilos Fardo',
      dataIndex: 'kilos_fardo',
      key: 'kilos_fardo',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Kilos Tara',
      dataIndex: 'kilos_tara',
      key: 'kilos_tara',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Kilos Neto',
      dataIndex: 'kilos_neto',
      key: 'kilos_neto',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Fecha/Hora',
      dataIndex: 'fecha_hora',
      key: 'fecha_hora',
      width: 160,
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      width: 200,
    },
    {
      title: 'Producto',
      dataIndex: 'producto',
      key: 'producto',
      width: 200,
    },
    {
      title: 'Nro. Producción',
      dataIndex: 'nro_produccion',
      key: 'nro_produccion',
      width: 150,
      align: 'right' as const,
    },
  ];

  const fetchData = async (idEmpresa: number, idProducto: number, token: string): Promise<any[]> => {
    const url = `${process.env.REACT_APP_ESTADISTICAS_URL}/detalle/desmote/${idEmpresa}/${idProducto}/`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error al cargar datos: ${response.status}`);
    }

    return await response.json();
  };

  return (
    <DetalleMetrica
      titulo="Detalle de Desmote"
      descripcion="Todos los fardos producidos en desmote"
      fetchData={fetchData}
      columns={columns}
      nombreArchivo="desmote"
    />
  );
};

export default DetalleDesmote;

